import { Box, Typography } from '@drone-js/core';
import React from 'react';
import { TabIndicatorProps, TabProps } from 'component/page/detail/DetailPageTabs/DetailPageTabs.selectors';

const TabIndicator = React.memo<TabIndicatorProps>(({ size }) => (
    <Box
        bottom="0"
        left="0"
        right="0"
        position="absolute"
        width="100%"
        height={size === 'm' ? '4px' : '2px'}
        backgroundColor="product.primary"
        borderRadius={size === 'm' ? ['8', '8', '0', '0'] : ['2', '2', '0', '0']}
    />
));

TabIndicator.displayName = 'TabIndicator';

const Tab = React.forwardRef<HTMLDivElement, React.PropsWithChildren<TabProps>>((props, ref) => {
    const { isActive, label, size, lineClamp, flex, width, ...rest } = props;

    return (
        <Box
            display="flex"
            minHeight="44px"
            position="relative"
            flex={flex}
            px={width === 'content-fit' ? '4' : '16'}
            justifyContent="center"
            alignItems="center"
            scrollSnapAlign="start"
        >
            <Box
                {...rest}
                ref={ref}
                as="button"
                role="link"
                py="4"
                px="12"
                borderRadius="24"
                interactive="product.primary"
                width="100%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
                textColor={isActive ? 'product.primary' : 'base.subtle'}
            >
                <Typography variant={size === 's' ? 'body-s-strong' : 'body-default-strong'} textAlign="center" lineClamp={lineClamp}>
                    {label}
                </Typography>
            </Box>
            {isActive && <TabIndicator size={size} />}
        </Box>
    );
});

Tab.displayName = 'Tab';

const TabMemoized = React.memo(Tab);
TabMemoized.displayName = 'TabItem';

export { TabMemoized as Tab };
